/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type mutationsSubscribeMutationVariables = {
    accountID: string;
    serviceID: string;
    currency: string;
};
export type mutationsSubscribeMutationResponse = {
    readonly subscribe: {
        readonly id: string;
    } | null;
};
export type mutationsSubscribeMutation = {
    readonly response: mutationsSubscribeMutationResponse;
    readonly variables: mutationsSubscribeMutationVariables;
};



/*
mutation mutationsSubscribeMutation(
  $accountID: ID!
  $serviceID: ID!
  $currency: String!
) {
  subscribe(input: {accountID: $accountID, serviceID: $serviceID, currency: $currency}) {
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "serviceID"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "accountID",
            "variableName": "accountID"
          },
          {
            "kind": "Variable",
            "name": "currency",
            "variableName": "currency"
          },
          {
            "kind": "Variable",
            "name": "serviceID",
            "variableName": "serviceID"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Subscription",
    "kind": "LinkedField",
    "name": "subscribe",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsSubscribeMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "mutationsSubscribeMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6cbc963cfd9fb035dc555a139b0c8ee3",
    "id": null,
    "metadata": {},
    "name": "mutationsSubscribeMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsSubscribeMutation(\n  $accountID: ID!\n  $serviceID: ID!\n  $currency: String!\n) {\n  subscribe(input: {accountID: $accountID, serviceID: $serviceID, currency: $currency}) {\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ba1f763495dc305df9f24b59bccc850f';
export default node;
